module.exports = __webpack_public_path__ + "img/MEASURE.3b7a0cf1.svg";